import {
  AriaTabs,
  Box,
  Flex,
  KdsCallout,
  KdsTab,
  KdsTabList,
  VStack,
} from "@kazaar-platform/design-system";
import { RiInformationLine } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { type OrderTab } from "../../../OrderItemPage.types.ts";
import { DesignProofsTab } from "./DesignProofsTab";
import { DocumentsTab } from "./DocumentsTab";
import { OrderItemDetailsTabsSkeleton } from "./OrderItemDetailsTabs.skeleton";
import { type OrderItemDetailsTabsProps } from "./OrderItemDetailsTabs.types";
import { StatusActionsTab } from "./StatusActionsTab";

export const OrderItemDetailsTabs = ({
  hasAModificationRequest,
  handleCancelModalOpen,
  isLoading,
  order,
  orderItem,
}: OrderItemDetailsTabsProps) => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslate();
  const navigate = useNavigate();

  const tabFromParams = (searchParams.get("tab") as OrderTab) ?? "information";

  const [selectedKey, setSelectedKey] = useState<OrderTab>(tabFromParams);

  const modificationRequestUrl = `/orders/${order.id}/order-items/${orderItem.id}/edit`;

  return (
    <Box pb="sp-xl2" w={{ base: "100%", xl: "50%" }}>
      <VStack gap="sp-md">
        <KdsCallout
          visible={hasAModificationRequest}
          iconLeft={RiInformationLine}
          state="warning"
          title={t(
            "order.myOrdersItemDetails.callout.modificationRequest.title"
          )}
          has="link"
          linkProps={{
            children: t(
              "order.myOrdersItemDetails.callout.modificationRequest.link"
            ),
            onPress: () => void navigate(modificationRequestUrl),
            size: "sm",
          }}
        />

        {isLoading ? (
          <OrderItemDetailsTabsSkeleton />
        ) : (
          <AriaTabs
            selectedKey={selectedKey}
            onSelectionChange={(key) => setSelectedKey(key as OrderTab)}
            style={{ flex: 1, marginBottom: "4rem" }} // TOREFACTO : Remove this once Tabs Component are refactored + refacto layouting
          >
            <VStack gap="sp-xl">
              <KdsTabList withBorder fullWidth>
                <KdsTab
                  id="information"
                  label={t("order.myOrdersItemDetails.tabs.information")}
                />

                <KdsTab
                  id="design_proofs"
                  label={t("order.myOrdersItemDetails.tabs.design_proofs")}
                />

                <KdsTab
                  id="documents"
                  label={t("order.myOrdersItemDetails.tabs.documents")}
                />
              </KdsTabList>

              <Flex direction="row-reverse" wrap="wrap">
                <StatusActionsTab
                  orderItem={orderItem}
                  setIsCancelModalOpen={handleCancelModalOpen}
                  isLoading={isLoading}
                  onTabNavigation={setSelectedKey}
                />

                <DesignProofsTab
                  orderItem={orderItem}
                  onTabNavigation={setSelectedKey}
                />

                <DocumentsTab orderItem={orderItem} />
              </Flex>
            </VStack>
          </AriaTabs>
        )}
      </VStack>
    </Box>
  );
};
